<template>
    <div>
        <SwipeCell :right-width="swipeCellRightWidth">
            <div slot="right" style="display: flex;height: 100%;margin-left: 3px;border-radius: 5px;overflow: hidden">
                <pf code="SAFETY_POSITION_EDIT">
                    <Button type="primary" style="height: 100%;border-radius: 0" @click="updatePoint">编辑</Button>
                </pf>
                <pf code="SAFETY_POSITION_DELETE">
                    <Button type="danger" style="height: 100%;border-radius: 0" @click="deletePoint">删除</Button>
                </pf>
            </div>
            <div class="topcode-wechat-taskSafe-item">
                <div class="body">
                    <div class="content">
                        <div class="flex-center-y center">
                            <img :src="downloadImg + taskPoint.image"/>
                            <div class="name" style="font-size: 14px">
                                <div class="title">{{taskPoint.name}}</div>
                                <div style="color: #7e7e7e">{{taskPoint.remark}}</div>
                            </div>
                            <pf code="SAFETY_POSITION_EDIT">
                                <TSwitch v-model="taskPoint.open" size="20" @change="changeState"/>
                            </pf>
                        </div>

                        <div style="display: flex;flex-wrap: wrap">
                            <div class="template-item" style="background: #00b6f9;"
                                 v-for="item in taskPoint.dayTemplateList" :key="item.id">
                                {{item.name}}
                            </div>
                        </div>
                        <div style="display: flex;flex-wrap: wrap">
                            <div class="template-item" style="background: #ec9900;"
                                 v-for="item in taskPoint.weekTemplateList" :key="item.id">
                                {{item.name}}
                            </div>
                        </div>
                        <div style="display: flex;flex-wrap: wrap">
                            <div class="template-item" v-for="item in taskPoint.monthTemplateList" :key="item.id">
                                {{item.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SwipeCell>
    </div>
</template>

<script>
    import {Button, Dialog, Icon, SwipeCell, Switch} from "vant"
    import {downloadImg} from "@/config"
    import {mapGetters} from 'vuex'

    export default {
        components: {
            Icon, Dialog, TSwitch: Switch, SwipeCell, Button
        },
        props: {
            taskPoint: {type: Object, required: true}
        },
        data() {
            return {
                show: false,
                downloadImg
            };
        },
        computed: {
            ...mapGetters({permissions: 'global/permissions'}),
            swipeCellRightWidth() {
                const canEdit = this.permissions.includes('SAFETY_POSITION_EDIT') ? 1 : 0
                const canDel = this.permissions.includes('SAFETY_POSITION_DELETE') ? 1 : 0
                const width = (canEdit + canDel) * 60
                return width ? width + 3 : 0
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            updatePoint() {
                // this.show = true;

                this.$emit('onUpdate', this.taskPoint)
            },
            switchPanel(type, data) {
                switch (type) {
                    case "safePointPopup":
                        this.show = !this.show;
                        break;
                    default:
                        break;
                }
            },
            changeState() {
                this.$http.tokiot.safety.position.update(this.taskPoint)

            },
            deletePoint(e) {
                e.stopPropagation()
                Dialog.confirm({
                    message: '确定删除吗',
                }).then(() => {
                    this.$toast.loading("正在处理中");
                    this.$http.tokiot.safety.position.delete({id: this.taskPoint.id})
                        .then(res => {
                            if (res) {
                                this.$toast.success("删除成功")
                                this.$emit("onRefresh")
                            } else {
                                this.$toast.fail(res.message)
                            }
                        })
                })
            }
        },
        watch: {}
    };
</script>

<style lang="less" scoped>

    .template-item {
        background: #07c160;
        padding: 2px 8px;
        margin-right: 5px;
        color: #fff;
        margin-bottom: 2px;
        border-radius: 3px;
    }

    .topcode-wechat-taskSafe-item {
        width: calc(100% - 2px);
        /*height: 225px;*/
        padding-bottom: 3px;
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px #cccccc solid;
        /*background: #51c332;*/

        & > .body {
            display: flex;
            & > .content {
                padding: 8px;
                width: 100%;
                & > .center {
                    padding: 5px;
                    display: flex;
                    /*background: #5cd8bc;*/
                    & > img {
                        width: 60px;
                        height: 60px;
                        background: #cccccc;
                        // border-radius: 8px;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        /*background: #7e7e7e;*/
                        flex-direction: column;
                        width: calc(100% - 50px);
                        & > div {
                            line-height: 1.5;
                        }
                    }
                }
            }
        }
    }
</style>
